import { INTERAX_COLORS } from '../../../constants/colors'

/**
 * Get background color/gradient based on variant
 */
export function getVariantBackground(variant: 'team' | 'individual'): string {
  const glassGradient = `linear-gradient(144.63deg, ${INTERAX_COLORS.white08} 0%, ${INTERAX_COLORS.white04} 100%)`

  if (variant === 'individual') {
    return `${glassGradient}, ${INTERAX_COLORS.heritageBlue40}`
  }

  return `${glassGradient}, ${INTERAX_COLORS.offBlack80}`
}

/**
 * Glass + heritage (or off-black) surface only — no flex layout.
 * Use for panels that need the same visual treatment as segment cards without center alignment.
 */
export function getGlassPanelSurfaceStyles(variant: 'team' | 'individual') {
  return {
    background: getVariantBackground(variant),
    backdropFilter: 'blur(18px)',
    border: `1px solid ${INTERAX_COLORS.white04}`,
    boxShadow: 'inset 0px 1px 0px rgba(255, 255, 255, 0.08), 0px 12px 24px rgba(10, 10, 10, 0.25)',
    borderRadius: '10px'
  } as const
}

/**
 * Get container styles for section card
 */
export function getSectionCardContainerStyles(variant: 'team' | 'individual') {
  return {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: { xs: '16px', sm: '20px', md: '24px' },
    gap: { xs: '16px', sm: '20px', md: '24px' },
    width: '100%',
    ...getGlassPanelSurfaceStyles(variant)
  } as const
}

/**
 * Get tab bar container styles
 */
export function getTabBarContainerStyles() {
  return {
    width: '100%',
    background: INTERAX_COLORS.offBlack,
    boxShadow: '2px 2px 2px rgba(255, 255, 255, 0.1), inset 2px 2px 3px rgba(0, 0, 0, 0.5)',
    borderRadius: '10px',
    padding: '4px'
  } as const
}

/**
 * Get content layout styles
 */
export function getContentLayoutStyles() {
  return {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'flex-start',
    padding: '0px',
    gap: '24px',
    width: '100%',
    alignSelf: 'stretch'
  } as const
}
